import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import LinkUI from 'ui/LinkUI';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const Contact: FC<IProps> = ({t}) => {
  const links = [
    {link: 'mailto:info@straus.md', keyWord: 'info@straus.md'},
    {
      link: `tel:${'022008008'}`,
      keyWord: `+373(22)008-008`,
    },
  ];

  return (
    <Flex w={['45%', 'auto']} flexDirection="column">
      <Text as="h2">{t('CONTACT')}</Text>
      {links.map((item, index) => (
        <LinkUI href={item.link} key={index}>
          <Text fontSize={['12px', '16px']} fontWeight="500" _hover={{color: colors.pink}} my="4px">
            {item.keyWord}
          </Text>
        </LinkUI>
      ))}
    </Flex>
  );
};
